import React, { use, useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { TextField } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { login, clearError, setUser } from "../../features/auth/authSlice";
import FormWrapper from "../../components/Forms/FormWrapper";
import { PasswordField } from "../../components/PasswordField";
import { LoginSchema } from "../../Validation/ValidationRule";
import DEFAULT_ROUTES from "../../constants/routes";
import { fetchUserLogin } from "../../utils/api";
import { setLoadingRedux } from "../../features/commonslice";

const LoginPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const {
    loading = false,
    error = null,
    user = null,
  } = useSelector((state) => state.auth || {});

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    mode: "onChange",
    resolver: zodResolver(LoginSchema),
    defaultValues: { email: "", password: "" },
  });

  const onSubmit = (data) => {
    dispatch(login(data.email, data.password));
  };

  const validateLogin = async () => {
    if(user) {
      navigate(DEFAULT_ROUTES.BASE_URL);
      return;
    };
    try {
      const {data=null, status=-1} = await fetchUserLogin();
      if(status === 1 && data) {
        dispatch(setUser({ user: data.user }));
        navigate(DEFAULT_ROUTES.BASE_URL);
        return;
      }
    } catch(error) {
      console.error("validateLogin", error)
    }
  }

  useEffect(()=>{
    validateLogin();
  }, [user]);
  
  useEffect(() => {
    return () => dispatch(clearError());
  }, [dispatch]);

  return (
    <FormWrapper
      title="QA Path"
      subheading="Login"
      onSubmit={handleSubmit(onSubmit)}
      loading={loading} // Set this to true while the form is submitting
      error={error}
      buttonName="Sign In"
      buttonColor="#3f51b5"
    >
      {/* Email Field */}
      <Controller
        name="email"
        control={control}
        render={({ field }) => (
          <TextField
            {...field}
            label="Email"
            fullWidth
            variant="outlined"
            margin="normal"
            error={!!errors.email}
            helperText={errors.email?.message}
            autoComplete="username"
          />
        )}
      />
      {/* Password Field */}
      <Controller
        name="password"
        control={control}
        render={({ field }) => (
          <PasswordField
            field={field}
            label="Password"
            error={!!errors.password}
            helperText={errors.password?.message}
            autoComplete="current-password"
          />
        )}
      />
    </FormWrapper>
  );
};

export default LoginPage;
